import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '../views/Start.vue'
import Imprint from '../views/Imprint.vue'
import Datenschutz from '../views/Datenschutz.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Start,
    meta: {
      title: 'Jugendkirche Mühlhausen',
      description: 'Jugendkirche Mühlhausen: Termine, Gottesdienste, Gruppen und Angebote für Jugendliche.'
    }
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: Imprint,
    meta: {
      title: 'Impressum – Jugendkirche Mühlhausen',
      description: 'Impressum der Jugendkirche Mühlhausen mit Anbieterkennzeichnung und Kontaktdaten.'
    }
  },
  {
    path: '/datenschutz',
    name: 'datenschutz',
    component: Datenschutz,
    meta: {
      title: 'Datenschutz – Jugendkirche Mühlhausen',
      description: 'Datenschutzerklärung der Jugendkirche Mühlhausen zur Verarbeitung personenbezogener Daten.'
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.afterEach((to) => {
  const { title, description } = to.meta || {}

  if (title) {
    document.title = title
  }

  if (description) {
    let descriptionTag = document.querySelector('meta[name="description"]')
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta')
      descriptionTag.setAttribute('name', 'description')
      document.head.appendChild(descriptionTag)
    }
    descriptionTag.setAttribute('content', description)
  }
})

export default router
